import React from 'react';
import ArAgeingReport from '../IFrameReports/ArAgeingReport';
import { makeReportOpener } from '../reportNavTools';

// linkClick: the redux link_click action, bound by the admin page.
export default function buildFinanceReportsSections(linkClick) {
  const open = makeReportOpener(linkClick);

  return [
    {
      title: 'Reports',
      cards: [
        {
          title: 'AR Ageing Report',
          description: 'Open the accounts-receivable ageing report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-clock',
          onClick: () => open(<ArAgeingReport />, 'AR Ageing Report', 'reports_arageingreport'),
        },
      ],
    },
  ];
}
